import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import qboLogo from '../../../../assets/logomark_quickbooks_online.svg';
import { white } from '../../../../styles/colors';
import { baseStyleSheet } from '../../../../styles/styles';
import { QuickBooksOnlineIntegrationGraphic } from '../../../svgs/graphics/QuickBooksOnlineIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { styleSheet } from './styles';

export const DashboardQuickBooksOnlineIntegrationCard = () => {
	const { getLogoImgProps, getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } =
		useIntegrationCard({
			closeIntegrationEventName: 'QuickBooksOnlineIntegrationClosed',
			enableUrlPath: '/integrations/QuickBooksOnline',
			integrationEnableEventName: 'QuickBooksOnlineIntegrationEnableClick',
			pendingAction: Api.PendingActions.ConnectQuickBooksOnline,
			checkApiPendingAction: true,
		});

	if (!showCard) {
		return null;
	}

	return (
		<IntegrationCard
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={QuickBooksOnlineIntegrationGraphic}
			headerLabel='QuickBooks Online Integration'
			logoBgColor={white}
			logoImgProps={getLogoImgProps({
				alt: 'QuickBooks Online Logo',
				className: css(styleSheet.logo),
				src: qboLogo,
			})}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect with QuickBooks Online',
				styleDeclaration: [baseStyleSheet.ctaButtonReverse, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>
				We are excited to announce that you can integrate your QuickBooks Online account with Levitate. With this
				integration, we will have the ability to pull client information, including names, email, phone number,
				birthdays, anniversaries, and more &mdash; making staying in touch even easier. We can also push our notes into
				QuickBooks Online.
			</p>
		</IntegrationCard>
	);
};
